import React from 'react';
import { getIn, useFormikContext } from 'formik';

import CanvasTheorySettings from './CanvasTheorySettings';

const CanvasTheorySettingsContainer = (props: any) => {
  const { values, setFieldValue } = useFormikContext<any>();

  const files = getIn(values, 'canvasTheory');

  const handleAddFileClick = () => {
    setFieldValue('canvasTheory', [
      ...files,
      {
        url: '',
      },
    ]);
  };

  const handleRemoveFileClick = (fileIndex: any) => {
    setFieldValue(
      'canvasTheory',
      values.canvasTheory.filter((_: any, index: any) => {
        return index !== fileIndex;
      }),
    );
  };

  return (
    <CanvasTheorySettings
      {...props}
      files={files}
      onAddFileClick={handleAddFileClick}
      onRemoveFileClick={handleRemoveFileClick}
    />
  );
};

export default React.memo(CanvasTheorySettingsContainer) as any;
